class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.handlePurchaseTypeChange = this.handlePurchaseTypeChange.bind(this);
    this.updateSellingPlanPrice = this.updateSellingPlanPrice.bind(this);
  }

  connectedCallback() {
    this.initWidget();
  }

  disconnectedCallback() {
    this.removeWidgetEvents();
  }

  initWidget() {
    this.purchaseTypeInputs = this.querySelectorAll('input[name="purchase-type"]');
    this.sellingPlanSelect = this.querySelector('.frequency__select-box');

    this.purchaseTypeInputs.forEach(input => {
      input.addEventListener('change', this.handlePurchaseTypeChange);
    });

    if (this.sellingPlanSelect) {
      const self = this;
      this.sellingPlanSelect.addEventListener('change', function () {
        // self.ensureSubscribeSelected();
        self.updateSellingPlanPrice();
      });
    }

    const initialSelection = this.querySelector('input[name="purchase-type"]:checked');
    this.handlePurchaseTypeChange({ target: initialSelection });
    this.updateSellingPlanPrice();
  }

  removeWidgetEvents() {
    if (this.purchaseTypeInputs) {
      this.purchaseTypeInputs.forEach(input => {
        input.removeEventListener('change', this.handlePurchaseTypeChange);
      });
    }

    if (this.sellingPlanSelect) {
      this.sellingPlanSelect.removeEventListener('change', this.updateSellingPlanPrice);
    }
  }

  handlePurchaseTypeChange(event) {
    const selectedValue = event.target.value;
    const isOneTime = selectedValue === 'one-time';
  
    if (this.sellingPlanSelect) {
      this.sellingPlanSelect.disabled = isOneTime;
    }
  
    const hiddenInput = this.querySelector('input.selected-selling-plan-id');
    if (hiddenInput) {
      hiddenInput.disabled = isOneTime;
    }
  }

  // ensureSubscribeSelected() {
  //   const subscribeInput = this.querySelector('input[name="purchase-type"][value="subscribe"]');
  //   if (subscribeInput && !subscribeInput.checked) {
  //     subscribeInput.checked = true;
  //     subscribeInput.dispatchEvent(new Event('change', { bubbles: true }));
  //   }
  // }

  updateSellingPlanPrice() {
    if (!this.sellingPlanSelect || !this.sellingPlanSelect.value) return;

    const sellingPlanId = this.sellingPlanSelect.value;

    const hiddenInput = this.querySelector('input.selected-selling-plan-id');
    if (hiddenInput) {
      hiddenInput.value = sellingPlanId;
    }
    const noscriptEl = document.getElementById('variant__json');
    if (!noscriptEl) return;

    const variantDataStr = noscriptEl.getAttribute('variant-data');
    if (!variantDataStr) return;

    const variantData = JSON.parse(variantDataStr);
    const allocations = variantData.selling_plan_allocations || [];

    const matchedAllocation = allocations.find(
      alloc => alloc.selling_plan_id == sellingPlanId
    );

    if (matchedAllocation && matchedAllocation.price_adjustments.length > 0) {
      const newPrice = matchedAllocation.price_adjustments[0].price;
      const compareAtPrice = matchedAllocation.compare_at_price;

      const salePrice = (newPrice / 100).toFixed(2);
      const originalPrice = (compareAtPrice / 100).toFixed(2);

      const subscriptionBox = this.querySelector('.subscription-box.box-style');
      if (subscriptionBox) {
        const salePriceElement = subscriptionBox.querySelector('.sale_price_esa');
        if (salePriceElement) salePriceElement.textContent = "$" + salePrice;

        const delElement = subscriptionBox.querySelector('.price del');
        if (delElement) delElement.textContent = "$" + originalPrice;
      }
    }
  }
}

customElements.define('subscription-widget', SubscriptionWidget);